import Vue from 'vue'
import VueRouter from 'vue-router'
import http from '@/utils/http'

Vue.use(VueRouter)

const routes = [
  { path: '/index', redirect: '/' },
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "index" */ '../views/index.vue'),
    meta:{
      title:'DF官网'
    }
  },
  {
    path: '/full-page',
    name: 'home',
    component: () => import(/* webpackChunkName: "index" */ '../views/full-page.vue'),
    meta:{
      title:'DF官网'
    }
  },
  {
    path: '/flagship-store/xx',
    name: 'xx',
    component: () => import(/* webpackChunkName: "flagship-store" */ '../views/flagship-store/xx.vue'),
    meta:{
      title:'线下旗舰店'
    }
  },
  {
    path: '/flagship-store/online-store',
    name: 'consult',
    component: () => import(/* webpackChunkName: "flagship-store" */ '../views/flagship-store/online-store.vue'),
    meta:{
      title:'线上旗舰店'
    }
  },
  {
    path: '/about-df/about-brand',
    name: 'about-brand',
    component: () => import(/* webpackChunkName: "about-df" */ '../views/about-df/about-brand.vue'),
    meta:{
      title:'关于品牌',
      breadcrumb:true
    }
  },
  {
    path: '/about-df/consult',
    name: 'consult',
    component: () => import(/* webpackChunkName: "about-df" */ '../views/about-df/consult.vue'),
    meta:{
      title:'最新资讯',
      breadcrumb:true,
      keepAlive:true
    }
  },
  {
    path: '/about-df/detail/:id',
    name: 'consult',
    component: () => import(/* webpackChunkName: "about-df" */ '../views/about-df/detail.vue'),
    meta:{
      title:'新闻详情',
      breadcrumb:true
    }
  },
  {
    path: '/product/series',
    name: 'series',
    component: () => import(/* webpackChunkName: "product" */ '../views/product/series.vue'),
    meta:{
      title:'启停系列'
    }
  },
  {
    path: '/product/rests',
    name: 'rests',
    component: () => import(/* webpackChunkName: "product" */ '../views/product/rests.vue'),
    meta:{
      title:'其他'
    }
  },
  {
    path: '/product/detail',
    name: 'detail',
    component: () => import(/* webpackChunkName: "product" */ '../views/product/detail.vue'),
    meta:{
      title:'产品详情'
    }
  },
  {
    path: '/support/download',
    name: 'support',
    component: () => import(/* webpackChunkName: "support" */ '../views/support/download.vue'),
    meta:{
      title:'物料下载中心'
    }
  },
  {
    path: '/support/to-join',
    name: 'support',
    component: () => import(/* webpackChunkName: "support" */ '../views/support/to-join.vue'),
    meta:{
      title:'申请旗舰店'
    }
  },
  {
    path: "/batterSearch",
    name: "batterSearch",
    meta:{
      title:"查询适配",
    },
    component:()=>import(/* webpackChunkName: "batterSearch" */ "@/views/batterySearch/index.vue")
  },
  {
    path: "/disclaimer/index",
    name: "disclaimer",
    meta:{
      title:"免责声明",
    },
    component:()=>import("@/views/disclaimer/index.vue")
  },


  {
    path: '/swiper',
    name: 'swiper',
    component: () => import(/* webpackChunkName: "about" */ '../views/swiper.vue')
  },
  {
    path: '/full-page',
    name: 'full-page',
    component: () => import(/* webpackChunkName: "about" */ '../views/full-page.vue')
  },
  
]

const router = new VueRouter({
  mode: 'history',
  //base: process.env.BASE_URL,
  routes
})

router.beforeEach((to,from,next)=>{
  window.scrollTo(0,0);
  document.title = to.meta.title
  Vue.prototype.$path = to.path
  webRecordLog()
  next()
})

function webRecordLog(params) {
  http.get("/userLog/webRecordLog", {
    name:'visit'
  }).then((res) => {
    
  });
}
export default router
